module.exports = __webpack_public_path__ + "static/Corprate_Careers_17-b51943e49ed179bed26ebcf79a1710f1.jpg";